window._ = require("lodash");

window.feather = require("feather-icons/dist/feather.min.js");

require("alpinejs");
